import { ICON_BUTTON_ICONS } from '../../../../components/buttons/IconButton';
import { UI_OPTION_KEYS } from '../../../../utils/constants/uiOptionKeys';
import { UI_OPTIONS } from '../../../../utils/constants/uiOptions';
import { PROFILER_SEARCH_RESULTS_COLUMNS } from './constants';

export default [
  {
    name: 'Relevance (default)',
    shortName: 'Relevance (default)',
    value: 'default',
    onlyForSearchCategory: UI_OPTIONS[UI_OPTION_KEYS.PROFILER_SEARCH_CATEGORY]['Characteristics']
  },
  {
    name: 'Default',
    shortName: 'Default',
    value: 'default',
    onlyForSearchCategory: UI_OPTIONS[UI_OPTION_KEYS.PROFILER_SEARCH_CATEGORY]['Industries']
  },
  // TD-2992: a bulk upload keeps the order of the uploaded file. `default` means "keep the
  // BE order" (no client-side sort), and the BE serves bulk results in upload order.
  {
    name: 'Upload order (default)',
    shortName: 'Upload order (default)',
    value: 'default',
    onlyForSearchCategory: UI_OPTIONS[UI_OPTION_KEYS.PROFILER_SEARCH_CATEGORY]['Bulk']
  },
  {
    name: 'Company name (a → z)',
    shortName: 'Company name',
    value: 'name-asc',
    icon: ICON_BUTTON_ICONS.SORT_ALPHA_DOWN
  },
  {
    name: 'Company name (z → a)',
    shortName: 'Company name',
    value: 'name-desc',
    icon: ICON_BUTTON_ICONS.SORT_ALPHA_DOWN_ALT
  },
  // Sorts on the ranks mapCompanyEntry derives from the register status (one per direction,
  // so "Other status" comes after the listed ones in both), so the numeric sort every list
  // already has applies; unknown comes last in both directions. No
  // `onlyForColumn`: the status shows under the company name, which is always visible.
  // No `shortName` or icon: the menus would show "Register status" with a 1 → 9 icon,
  // which says nothing about the order; the full name does.
  {
    name: 'Register status (active first)',
    value: '_registerStatusRank-asc'
  },
  {
    name: 'Register status (non-active first)',
    value: '_registerStatusNonActiveRank-desc'
  },
  {
    name: 'Sales (1 → 9)',
    shortName: 'Sales',
    value: '_revenue-asc',
    icon: ICON_BUTTON_ICONS.SORT_NUMERIC_DOWN,
    onlyForColumn: PROFILER_SEARCH_RESULTS_COLUMNS.SALES
  },
  {
    name: 'Sales (9 → 1)',
    shortName: 'Sales',
    value: '_revenue-desc',
    icon: ICON_BUTTON_ICONS.SORT_NUMERIC_DOWN_ALT,
    onlyForColumn: PROFILER_SEARCH_RESULTS_COLUMNS.SALES
  },
  {
    name: 'Employees (1 → 9)',
    shortName: 'Employees',
    value: '_employees-asc',
    icon: ICON_BUTTON_ICONS.SORT_NUMERIC_DOWN,
    onlyForColumn: PROFILER_SEARCH_RESULTS_COLUMNS.EMPLOYEES
  },
  {
    name: 'Employees (9 → 1)',
    shortName: 'Employees',
    value: '_employees-desc',
    icon: ICON_BUTTON_ICONS.SORT_NUMERIC_DOWN_ALT,
    onlyForColumn: PROFILER_SEARCH_RESULTS_COLUMNS.EMPLOYEES
  },
  {
    name: 'CAGR 3Y (%) (1 → 9)',
    shortName: 'CAGR 3Y (%)',
    value: '_cagr3Y-asc',
    icon: ICON_BUTTON_ICONS.SORT_NUMERIC_DOWN,
    onlyForColumn: PROFILER_SEARCH_RESULTS_COLUMNS.CAGR3Y
  },
  {
    name: 'CAGR 3Y (%) (9 → 1)',
    shortName: 'CAGR 3Y (%)',
    value: '_cagr3Y-desc',
    icon: ICON_BUTTON_ICONS.SORT_NUMERIC_DOWN_ALT,
    onlyForColumn: PROFILER_SEARCH_RESULTS_COLUMNS.CAGR3Y
  },
  {
    name: 'CAGR 4Y (%) (1 → 9)',
    shortName: 'CAGR 4Y (%)',
    value: '_cagr4Y-asc',
    icon: ICON_BUTTON_ICONS.SORT_NUMERIC_DOWN,
    onlyForColumn: PROFILER_SEARCH_RESULTS_COLUMNS.CAGR4Y
  },
  {
    name: 'CAGR 4Y (%) (9 → 1)',
    shortName: 'CAGR 4Y (%)',
    value: '_cagr4Y-desc',
    icon: ICON_BUTTON_ICONS.SORT_NUMERIC_DOWN_ALT,
    onlyForColumn: PROFILER_SEARCH_RESULTS_COLUMNS.CAGR4Y
  },
  {
    name: 'EBIT Margin (%) (1 → 9)',
    shortName: 'EBIT Margin (%)',
    value: '_ebitPercentage-asc',
    icon: ICON_BUTTON_ICONS.SORT_NUMERIC_DOWN,
    onlyForColumn: PROFILER_SEARCH_RESULTS_COLUMNS.EBIT_MARGIN
  },
  {
    name: 'EBIT Margin (%) (9 → 1)',
    shortName: 'EBIT Margin (%)',
    value: '_ebitPercentage-desc',
    icon: ICON_BUTTON_ICONS.SORT_NUMERIC_DOWN_ALT,
    onlyForColumn: PROFILER_SEARCH_RESULTS_COLUMNS.EBIT_MARGIN
  }
];
